import React from 'react';
import PropTypes from 'prop-types';
import { ClapSpinner } from 'react-spinners-kit';
import * as Ui from './styles';

const propTypes = {
  running: PropTypes.bool,
  size: PropTypes.number,
};

const defaultProps = {
  size: 30,
  running: false,
};

export default function Loading(props) {
  const { running, size } = props;

  return (
    <Ui.Loading>
      <ClapSpinner
        size={size}
        loading={running}
        frontColor="#04e0e0"
        backColor="#f4f4f4"
      />
    </Ui.Loading>
  );
}

Loading.propTypes = propTypes;
Loading.defaultProps = defaultProps;
